import {
  __asyncGenerator,
  __await,
  __forAwait
} from "../chunk-LMOQIXV4.js";
import { parse } from "graphql";
import {
  createWebsocketsFetcherFromClient,
  multipartHttpTransport,
  simpleHttpTransport
} from "../create-fetcher/lib";
function classifySelectedOperation(query, operationName) {
  let document;
  try {
    document = parse(query);
  } catch (e) {
    return;
  }
  const operations = document.definitions.filter(
    (def) => def.kind === "OperationDefinition"
  ), operation = operationName ? operations.find((op) => {
    var _a;
    return ((_a = op.name) == null ? void 0 : _a.value) === operationName;
  }) : operations.length === 1 ? operations[0] : void 0;
  return operation == null ? void 0 : operation.operation;
}
const byteLength = (value) => typeof TextEncoder == "undefined" ? value.length : new TextEncoder().encode(value).length;
function toSubscriptionResponse(event, startMs) {
  const errors = event == null ? void 0 : event.errors;
  return {
    ok: !Array.isArray(errors) || errors.length === 0,
    body: event,
    timing: { totalMs: performance.now() - startMs },
    size: { response: byteLength(JSON.stringify(event)) }
  };
}
function createTransport(opts) {
  var _a, _b;
  const httpFetchOrFalse = opts.fetch || typeof window != "undefined" && window.fetch;
  if (!httpFetchOrFalse)
    throw new Error("No valid fetch implementation available");
  const httpFetch = httpFetchOrFalse, incrementalDelivery = opts.enableIncrementalDelivery !== !1, fetcherOptions = {
    url: opts.url,
    headers: opts.headers
  }, supportedMethods = (_a = opts.supportedMethods) != null ? _a : ["POST"];
  if (opts.method !== void 0 && !supportedMethods.includes(opts.method))
    throw new Error(
      `"${opts.method}" is not in supportedMethods (${supportedMethods.join(", ")}). Either add it to supportedMethods or omit the method option.`
    );
  let activeMethod = (_b = opts.method) != null ? _b : supportedMethods.includes("POST") ? "POST" : supportedMethods[0];
  function send(req) {
    var _a2;
    const params = {
      query: req.query,
      operationName: (_a2 = req.operationName) != null ? _a2 : void 0,
      variables: req.variables,
      extensions: req.extensions
    }, fetcherOpts = req.headers || req.signal ? { headers: req.headers, signal: req.signal } : void 0, selectedOperation = classifySelectedOperation(
      req.query,
      req.operationName
    );
    if (selectedOperation === "subscription")
      return subscribe(opts.subscriptionClient, params);
    let method = activeMethod;
    if (activeMethod !== "POST" && selectedOperation === "mutation") {
      if (!supportedMethods.includes("POST"))
        throw new Error(
          `Cannot execute a mutation over ${activeMethod}. This transport does not support POST (supportedMethods: ${supportedMethods.join(", ")}). Add POST to supportedMethods or switch to a POST-capable transport.`
        );
      method = "POST";
    }
    return incrementalDelivery ? multipartHttpTransport(
      fetcherOptions,
      httpFetch,
      method
    )(params, fetcherOpts) : simpleHttpTransport(
      fetcherOptions,
      httpFetch,
      method
    )(params, fetcherOpts);
  }
  const transport = {
    url: opts.url,
    method: activeMethod,
    supportedMethods,
    send
  };
  return supportedMethods.length > 1 && (transport.setMethod = (method) => {
    if (!supportedMethods.includes(method))
      throw new Error(
        `"${method}" is not supported by this transport (supportedMethods: ${supportedMethods.join(", ")}).`
      );
    activeMethod = method, transport.method = method;
  }), transport;
}
function subscribe(subscriptionClient, params) {
  return __asyncGenerator(this, null, function* () {
    if (!subscriptionClient)
      throw new Error(
        "createTransport is not configured for subscriptions. Pass a `subscriptionClient` (e.g. `graphql-ws`'s `createClient({ url })` or `graphql-sse`'s `createClient({ url })`). See docs/migration/graphiql-6.0.0.md."
      );
    const iterable = createWebsocketsFetcherFromClient(subscriptionClient)(params), startMs = performance.now();
    try {
      for (var iter = __forAwait(iterable), more, temp, error; more = !(temp = yield new __await(iter.next())).done; more = !1) {
        const event = temp.value;
        yield toSubscriptionResponse(event, startMs);
      }
    } catch (temp) {
      error = [temp];
    } finally {
      try {
        more && (temp = iter.return) && (yield new __await(temp.call(iter)));
      } finally {
        if (error)
          throw error[0];
      }
    }
  });
}
export {
  createTransport
};
